import React from 'react';
import {DashboardMensajesPorPeriodo, DashboardMensajesPorPeriodoFields} from "../types/dashboard";
import CardActions from "../../sistema/components/CardActions";
import {
  axisClasses,
  ChartsTooltip,
  ChartsXAxis,
  ChartsYAxis,
  LinePlot,
  MarkPlot,
  ResponsiveChartContainer
} from "@mui/x-charts";

interface MensajesPorPeriodoChartProps {
  data: DashboardMensajesPorPeriodo[]
}

function MensajesPorPeriodoChart({data}: MensajesPorPeriodoChartProps) {
  return (
    <CardActions title={'Mensajes por período'} colapsable>
      <ResponsiveChartContainer
        height={400}
        dataset={data}
        series={[
          {
            type: 'line',
            dataKey: DashboardMensajesPorPeriodoFields.CantMensajes,
            label: '# Mensajes',
            id: 'cantMensajes',
            yAxisId: 'cantMensajes',
            curve: 'linear',
            showMark: true,
          },

        ]}
        xAxis={[
          {
            dataKey: DashboardMensajesPorPeriodoFields.Periodo,
            scaleType: 'point',
            id: 'x-axis-id',
          },
        ]}
        yAxis={[{
          id: 'cantMensajes',

        }]}
        margin={{left: 70, right: 70}}
        sx={{
          [`.${axisClasses.left} .${axisClasses.label}`]: {
            transform: 'translate(-25px, 0)',
          },
          [`.${axisClasses.right} .${axisClasses.label}`]: {
            transform: 'translate(30px, 0)',
          },
        }}

      >
        <LinePlot/>
        <MarkPlot/>


        <ChartsTooltip/>


        <ChartsXAxis label="Período" position="bottom" axisId="x-axis-id"/>
        <ChartsYAxis axisId="cantMensajes" label="Mensajes"/>


      </ResponsiveChartContainer>
    </CardActions>
  );
}

export default MensajesPorPeriodoChart;